import React, { useEffect, useState } from 'react';
import { Fab, ListItem, ListItemIcon, ListItemText, makeStyles, Tooltip } from '@material-ui/core';

import { fetchAllManuals } from 'app/store/slices/manuals';
import { SYSTEM_DOC_TYPES } from 'app/utils/constants';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import HelpIcon from '@material-ui/icons/Help';

import styles from './styles';
import { downloadFile } from "../../utils/forms/files";
const useStyles = makeStyles(styles);

const ManualButton = props => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {
    rest: { type, menu },
  } = props;

  const manuals = useSelector(state => state.manuals.files);
  const [loadingManuals, setLoadingManuals] = useState(false);
  const [manualList, setManualList] = useState([]);
  const [manualTitle, setManualTitle] = useState('');

  useEffect(() => {
    const init = async () => {
      if (manuals.length === 0) {
        setLoadingManuals(true);
        await dispatch(fetchAllManuals());
        setLoadingManuals(false);
      }
    };
    init();
  }, [dispatch, manuals.length]);

  useEffect(() => {
    const init = () => {
      if (type) {
        setManualTitle(SYSTEM_DOC_TYPES[type].label);
        setManualList(
          manuals.filter(man => {
            return man.tpDocumentoSistema === type;
          })
        );
      }
    };
    init();
  }, [manuals, type]);

  const handleClickManual = async () => {
    await downloadFile({ idFile: manualList[0].idFile, dispatch }, null);
  };

  if (loadingManuals || manualList.length === 0) {
    return <></>;
  }

  if (menu) {
    return (
      <ListItem button divider onClick={() => handleClickManual()}>
        <ListItemIcon>
          <HelpIcon className={classes.listItemIcon} />
        </ListItemIcon>
        <ListItemText
          disableTypography
          className={classes.listItemText}
          primary={<FormattedMessage id="LABELS.COMMONS.MANUAL" />}
        />
      </ListItem>
    );
  }

  return (
    <Tooltip title={manualTitle}>
      <Fab
        className={classes.fab}
        style={{ fontSize: '30px' }}
        onClick={() => handleClickManual()}
        {...props}
      >
        ?
      </Fab>
    </Tooltip>
  );
};

export default ManualButton;
